import React, { FC, useState, useEffect, useRef, JSX } from 'react';
import Styles from './StickyBottomSheet.module.scss';
import Row from '../ResponsiveRow/row';
import { StickyBottomSheetPropConfig } from '../../services/StickyBottomSheetConfig';
import { createCartV2, fetchOfferingDataV2 } from '../../services/LineTableService';
import RichText from '../richtext';
import ProductPriceV3 from '../ProductDetailsV3/ProductPriceV3';
import { fetchPrice } from '../lineTable/ProductV3';
import { DEFAULT_MOBILEPOSTPAID_BUNDLE } from '../../utils/constants';
import Cookies from 'js-cookie';
import { ADDTOCART, STICKYBOTTOMSHEET } from '../../Analytics/AnalyticsConstants';
import { trackEligibleItem } from '../../Analytics/items';
import Dotloader from '../Dotloader/Dotloader';
import { createPortal } from 'react-dom';

export interface FalconTitleInterface {
  text: string;
}

const StickyBottomSheet: FC<any> = ({ content, sbStaticConstants }: any): JSX.Element => {
  const [offeringData, setOfferingData] = useState<any[]>([]);
  const endPoint = StickyBottomSheetPropConfig?.getInstance()?.getBaseUrl();
  const cartEndPoint = StickyBottomSheetPropConfig?.getInstance()?.getCartUrl();
  const [priceCollection, setPriceCollection] = useState<any>();
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [portalPosition, setPortalPosition] = useState<any>();
  const [screenWidth, setScreenWidth] = useState<number>(0);
  const [chatLoaded, setChatLoaded] = useState<boolean>(false);
  const elementRef = useRef<HTMLDivElement>(null);
  const chatButtonBehaviour = content?.chatButtonBehaviour;
  let retrys: number = 0;

  useEffect(() => {
    if (document.body) {
      setPortalPosition(document?.body);
    }
  }, []);
  useEffect(() => {
    const requestBody = [
      {
        id: content?.productId,
        ...(content?.promotionId?.length > 0 && { promoIds: [content.promotionId] })
      }
    ];
    offeringData?.length === 0 &&
      fetchOfferingDataV2(requestBody, endPoint)
        .then((data: any) => {
          if (data && Object.keys(data)?.length > 0) {
            setOfferingData(data);
            const showPrice = fetchPrice([data[content?.productId]], true);
            setPriceCollection(showPrice);
            setTimeout(handleResize, 1000);
          }
        })
        .catch((error: any) => {
          // eslint-disable-next-line no-console
          console.log('error--->', error);
        });
  }, []);

  const callCart = (product: any) => {
    setShowLoader(true);
    Object.keys(offeringData)?.length !== 0 &&
      trackEligibleItem(ADDTOCART, [offeringData[product?.productId]], '', STICKYBOTTOMSHEET);
    //Create cart
    Object.keys(offeringData)?.length !== 0 &&
      createCartV2(
        [offeringData[product?.productId]],
        '',
        product?.promotionId ? product?.promotionId : DEFAULT_MOBILEPOSTPAID_BUNDLE,
        cartEndPoint,
        product?.productType
      )
        .then((res) => {
          Cookies.remove('one-commerce-cartId', { path: '/' });
          // saving newly created cartid in the cookies.
          Cookies.set('one-commerce-cartId', res?.id, { path: '/' });
          Cookies.set('cartProduct', product?.productId, { path: '/' });
          window.location.href = product?.checkoutUrl?.cached_url;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
          setShowLoader(false);
        })
        .finally(() => {
          setShowLoader(false);
        });
  };

  useEffect(() => {
    const sprLiveChatApp =
      typeof window !== undefined && document.getElementById('spr-live-chat-app');

    if (sprLiveChatApp && elementRef?.current) {
      let styleTag = document.querySelector('head style#spr-live-chat-app-styles');
      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = 'spr-live-chat-app-styles';
        document.head.appendChild(styleTag);
      }

      if (chatButtonBehaviour === 'movetop') {
        const elementHeight = elementRef?.current.offsetHeight - 70 || 180;
        styleTag.textContent = `#spr-live-chat-app > div { margin-bottom: ${elementHeight}px !important; }`;
      } else if (chatButtonBehaviour === 'hide') {
        styleTag.textContent = `#spr-live-chat-app { display: none !important; }`;
      }
    }
  }, [screenWidth, elementRef, setChatLoaded]);

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };
  const checkForChatButton = () => {
    const sprLiveChatApp =
      typeof window !== 'undefined' && document.getElementById('spr-live-chat-app');

    if (sprLiveChatApp) {
      setChatLoaded(true);
      setTimeout(handleResize, 1000);
      window && window.addEventListener('resize', handleResize);
    } else {
      if (retrys < 50) {
        retrys++;
        setTimeout(checkForChatButton, 250);
      }
    }
  };
  useEffect(() => {
    chatButtonBehaviour?.length && checkForChatButton();
  }, []);

  return (
    <div
      className={`${Styles['sticky-bottom-sheet']} ${priceCollection && Styles['ready']}`}
      id='stickyBottomSheet'
      ref={elementRef}
    >
      <Row>
        <div className={Styles['content-wrapper']}>
          <div className={Styles['title-wrapper']}>
            <div>
              <div className={Styles['title']}>{content?.title} </div>
              {priceCollection && (
                <ProductPriceV3
                  content={content}
                  priceCollection={priceCollection}
                  sbStaticConstants={sbStaticConstants}
                  toggleSwitch={false}
                />
              )}
            </div>

            <div className={Styles['description']}>
              <RichText content={content?.description} />
            </div>
          </div>
          <div className={Styles['checkoutHolder']}>
            {showLoader &&
              portalPosition &&
              createPortal(<Dotloader keyParams='loading' />, portalPosition)}
            {content?.orderNowButton && (
              <button
                className={`${Styles['proceedToCheckoutButton']} proceedToCheckoutButton`}
                onClick={() => callCart(content)}
              >
                <span className='checkoutButton'>{content?.orderNowButton}</span>
              </button>
            )}
          </div>
        </div>
      </Row>
    </div>
  );
};

export default StickyBottomSheet;
